// extracted by mini-css-extract-plugin
export default {"referral-widget":"Tm","referral-page":"Um","label":"Vm","subHed":"Wm","profile-container":"Xm","referral-container":"Ym","referral-header":"Zm","shareMethodRow":"an","shareMethod":"bn","active":"cn","referral-stat":"en","blockwrapper":"fn","referralLink":"gn","bold":"hn","semibold":"in","shareAgainButton":"jn","policy":"kn","narrowWrapper":"ln"};
    if(module.hot) {
      // 1714654883234
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  